import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'Matías',
  city: 'Córdoba',
  quote: 'Antes no pasaba del segundo round sin ahogarme. Ahora termino los 5 rounds de sparring y sigo con energía. La rutina de fuerza cambió mi juego por completo.'
}, {
  name: 'Federico',
  city: 'CABA',
  quote: 'Venía de dos lesiones de hombro seguidas. El protocolo de prevención y los calentamientos me salvaron. Hace 6 meses que entreno sin dolores.'
}, {
  name: 'Lucas',
  city: 'Rosario',
  quote: 'Siempre fui el más liviano y me pasaban la guardia fácil. Con el Tomo 2 gané una fuerza de base que sorprende a los pesados de mi academia.'
}, {
  name: 'Ignacio',
  city: 'Mendoza',
  quote: 'La calculadora de carga es oro puro. Dejé de adivinar qué peso levantar y mi fuerza explotó sin sobreentrenarme. 100% recomendado para BJJ.'
}, {
  name: 'Santiago',
  city: 'La Plata',
  quote: 'Entreno MMA amateur y no sabía cómo combinar pesas con striking y grappling. El planificador semanal me ordenó la vida. Rindo el doble en el tatami.'
}];
export function Testimonials() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-160">
      <div className="text-center mb-12" data-id="element-161">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-4" data-id="element-162">
          Resultados Reales de{' '}
          <span className="text-amber-400" data-id="element-163">Practicantes Reales</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-164">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-zinc-900/50 border border-zinc-800 p-6 rounded-2xl flex flex-col" data-id="element-165">
            <div className="flex gap-1 mb-4" data-id="element-166">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-167" />)}
            </div>
            <p className="text-zinc-300 italic mb-6 flex-grow" data-id="element-168">"{t.quote}"</p>
            <div className="mt-auto pt-4 border-t border-zinc-800/50" data-id="element-169">
              <p className="font-bold text-white" data-id="element-170">{t.name}</p>
              <p className="text-sm text-zinc-500" data-id="element-171">{t.city}, Argentina</p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}